export const environment = {
  production: false,
  current: 'dev',

  //DEPLOYMENT ENVIRONMENT PROD
  uploadDefaultUrl: "/PAOnlineTools/PAPortalUploadService/api/Upload/ExchangeUpload",
  BaseURL: "/PAOnlineTools/RegistrationPortal",
  BaseClientURL: "/PAOnlineTools/RegistrationPortalClient",

  // public static BaseURL ="/PAOnlineTools/Registration_Portal_Multi_Test";

  //PROD ConnectionStrings in DEV
  //uploadDefaultUrl : "https://localhost:7084/api/Upload/ExchangeUpload",
  // public static BaseURL ="https://localhost:44306";

  // Development"                  
  //"http://localhost/PAOnlineTools/PAPortalUploadService/"
  // public static uploadDefaultUrl = "http://localhost/PAOnlineTools/PAPortalUploadService/api/Upload/ExchangeUpload"
  

  //General
  // BaseURL :"/PAOnlineTools/RegistrationPortal",
  // uploadDefaultUrl : "/PAOnlineTools/PAPortalUploadService/api/Upload/ExchangeUpload",

  CDNPath: "/CDN/",
  BannerBackground: "Banner/banner.jpg",
  Logo: "Logo/logo.png",
  CountySeal: "Logo/county-seal.png",
  IconPrint: "Icons/icon-print.png",
  IconFacebook: "Icons/icon-facebook.png",
  IconX: "Icons/x.png",

  //Agendas
  GetAllAgendas: "/Agenda/GetAllAgendas/",

  //Email
  SendEmail: "/Email/SendEmail",
  SendUploadTransactionEmail: "/Email/SendUploadTransactionEmail",
  SendAxiaTransactionEmail: "/Email/SendAxiaTransactionEmail",

  //Upload
  GetAllUploadedEvidence: "/Uploads/GetAllUploadedEvidence/",
  insertUploadTransaction: "/Uploads/InsertUploadTransaction/",
  insertUploadFile: "/Uploads/InsertUploadFile/",
  ExecuteAxiaTransfer: "/Uploads/ExecuteAxiaTransfer/",
  multiplyFiles: "/Uploads/multiplyFiles/",
  uploadFolderName: "VABAgentExchange",

  //Directory
  isAppOffline: "/Directory/isAppOffline/",
  CreateDirectory: "/Directory/CreateDirectory",
  UploadDirectoryPath: "\\\\ProdData1PAnet.miamidade.gov\\Applications_inetpub\\PAPortalAttachments\\",

  //PortalUserAccount
  Refresh: "/PortalUserAccount/Refresh/",
  isAccountActive: "/PortalUserAccount/isAccountActive/",
  checkUserNameAvailability: "/PortalUserAccount/checkUserNameAvailability/",
  GetUserByGuid: "/PortalUserAccount/GetUserByGuid/",
  ValidateRecoveryGuid: "/PortalUserAccount/ValidateRecoveryGuid/",
  ValidateEmailRecoveryGuid: "/PortalUserAccount/ValidateEmailRecoveryGuid/",
  authenticate: "/PortalUserAccount/authenticate/",
  UpdateUser: "/PortalUserAccount/UpdateUser/",
  emailPasswordRecovery: "/PortalUserAccount/emailPasswordRecovery/",
  confirmEmailUpdate: "/PortalUserAccount/confirmEmailUpdate/",
  UpdateAgentsInfo: "/PortalUserAccount/UpdateAgentsInfo/",
  UpdateAgentsPassword: "/PortalUserAccount/UpdateAgentsPassword/",

  // Route
  UpdateAgentsConfirmEmail: "/#/confirm-email/",
};